var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.6,
    height: 67.7,
    viewBox: "0 0 67.6 67.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.91,
    y1: 57.74,
    x2: 57.69,
    y2: 9.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f48a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,67.7A33.85,33.85,0,1,0,0,33.8,33.82,33.82,0,0,0,33.8,67.7Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.19,47a1.75,1.75,0,0,1-.57,2.41,12.58,12.58,0,0,1-6.62,2,10.7,10.7,0,0,1-4.9-1.19A12,12,0,0,1,16.85,40a18.52,18.52,0,0,1,1.87-9.07,28.66,28.66,0,0,1,5.44-7.39H18a1.75,1.75,0,0,1,0-3.5h8.1a4.06,4.06,0,0,1,4,4.05v8.1a1.75,1.75,0,0,1-3.5,0V26a24.77,24.77,0,0,0-4.78,6.46,14.75,14.75,0,0,0-1.52,7.3,8.56,8.56,0,0,0,4.36,7.31,8.07,8.07,0,0,0,8.07-.67A1.75,1.75,0,0,1,35.19,47ZM49.7,44.15H43.55A28.34,28.34,0,0,0,49,36.76a18.52,18.52,0,0,0,1.87-9.07A12,12,0,0,0,44.6,17.51a11.49,11.49,0,0,0-11.52.8,1.75,1.75,0,1,0,1.84,3A8.09,8.09,0,0,1,43,20.62a8.57,8.57,0,0,1,4.35,7.3,14.76,14.76,0,0,1-1.52,7.31,24.94,24.94,0,0,1-4.78,6.46V35.5a1.75,1.75,0,0,0-3.5,0v8.1a4.06,4.06,0,0,0,4.05,4h8.1a1.75,1.75,0,0,0,0-3.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.87b93a4c6e6ac0dfc4cb3023fdec2ba6.svg";
export { ForwardRef as ReactComponent };